// extracted by mini-css-extract-plugin
module.exports = {"trait-box":"trait-box_3JjL","items":"items_20fq","item":"item_abjp","img":"img_3Ijq"};